<template>
  <Transition name="nested" duration="700">
    <div v-if="showContact" class="fixed top-0 left-0 w-full h-full z-[62]">
      <div @click="toggleShowContact" class="absolute w-full h-full bg-black bg-opacity-50 overlay"></div>
      <div class="absolute right-0 top-0 w-[95%] md:w-auto md:max-w-[30rem] lg:max-w-[30vw] sidebar-diagonal">
        <div class="relative p-6 md:p-10 lg:p-[2vw] rounded-bl-3xl lg:rounded-bl-[2vw] bg-ip-color-12 space-y-6 md:space-y-12 lg:space-y-[2vw] text-white">
          <div class="flex justify-between items-center contact-text opacity-0">
            <div class="figtree font-medium text-2xl leading-8 md:text-[2.4vw] md:leading-[2.8vw] lg:text-[2vw] lg:leading-[2.6vw]">Let's Connect</div>
            <button @click="toggleShowContact">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 md:h-[1.8vw] md:w-[1.8vw] lg:h-[1.5vw] lg:w-[1.5vw]" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
              </svg>
            </button>
          </div>
          <div class="space-y-6 lg:space-y-[1.2vw]">
            <div class="space-y-1 lg:space-y-[.2vw] contact-text opacity-0">
              <div class="figtree font-semibold text-[16px] lg:text-[1.2vw] lg:leading-[1.8vw] uppercase">Address</div>
              <a href="https://maps.app.goo.gl/oEUXhDVi7Xuv7Mti9" target="_blank" class="figtree font-medium text-[3.5vw] md:text-[1.4vw] lg:text-[1.1vw] leading-6 lg:leading-[1.5vw]">
                PT. KANITA BUMI LESTARI <br>
                Gedung Office 8, Level 18-A. Jl. Senopati No. 8B, <br>
                Kawasan SCBD Kel. Senayan, Kec. Kebayoran Baru, <br>
                Jakarta Selatan 12190
              </a>
            </div>
            <!-- <div class="space-y-1 lg:space-y-[.2vw] contact-text opacity-0">
              <div class="figtree font-semibold text-[16px] lg:text-[1.2vw] lg:leading-[1.8vw]">Telephone</div>
              <div class="figtree font-medium text-[14px] leading-6 lg:text-[1.1vw] lg:leading-[1.5vw]"></div>
              <a target="_blank" class="lg:hidden relative w-full block figtree font-medium text-[14px] leading-6 md:text-[1.4vw] md:leading-[2vw] h-full text-white focus:text-white hover:text-white" href="tel:+622122773278">+62 21 22773278</a>
              <button @click="copyToClipboard('phone', '+622122773278')" class="hidden lg:flex items-center gap-2 figtree font-medium text-[14px] leading-6 md:text-[1.4vw] md:leading-[2vw] lg:text-[1.1vw] lg:leading-[1.5vw]">
                <span>{{ copyTextLang.phone }}</span>
                <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 md:h-[1.8vw] md:w-[1.8vw] lg:h-[1.5vw] lg:w-[1.5vw]" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                </svg>
              </button>
            </div> -->
            <div class="space-y-1 lg:space-y-[.2vw] contact-text opacity-0">
              <div class="figtree font-semibold text-[3.5vw] md:text-[1.4vw] lg:text-[1.2vw] lg:leading-[1.8vw] uppercase">Linkedin</div>
              <a href="https://linkedin.com/in/impacthink-indonesia-8561a62b0" target="_blank" class="block figtree font-medium text-[14px] leading-6 lg:text-[1.1vw] lg:leading-[1.5vw]">ImpacThink Indonesia</a>
            </div>
            <div class="space-y-1 lg:space-y-[.2vw] contact-text opacity-0">
              <div class="figtree font-semibold text-[3.5vw] md:text-[1.4vw] lg:text-[1.2vw] lg:leading-[1.8vw] uppercase">Email</div>
              <button @click="copyToClipboard('email', 'hello@impacthink.id')" class="flex items-center gap-2 figtree font-medium text-[14px] leading-6 md:text-[1.4vw] md:leading-[2vw] lg:text-[1.1vw] lg:leading-[1.5vw]">
                <span>{{ copyTextLang.email }}</span>
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 md:h-[1.8vw] md:w-[1.8vw] lg:h-[1.5vw] lg:w-[1.5vw]" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                </svg>
              </button>
            </div>
            <div class="space-y-1 lg:space-y-[.2vw] contact-text opacity-0">
              <div class="figtree font-semibold text-[3.5vw] md:text-[1.4vw] lg:text-[1.2vw] lg:leading-[1.8vw] uppercase">Instagram</div>
              <a href="https://www.instagram.com/impacthink.id/" target="_blank" class="block figtree font-medium text-[14px] leading-6 lg:text-[1.1vw] lg:leading-[1.5vw]">@impacthink.id</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup>
const navbarStore = useNavbarStore();
const { $anime } = useNuxtApp();

const emits = defineEmits(['close']);
const showContact = computed(() => navbarStore.$state.showContact);
const toggleShowContact = async () => {
  navbarStore.toggleContact();
};

const copyTextLang = ref({
  email: 'hello@impacthink.id',
  phone: '+62 21 22773278',
});

const resetCopyTextLang = ref({
  email: 'hello@impacthink.id',
  phone: '+62 21 22773278',
});

const copyToClipboard = (name, text) => {
  navigator.clipboard.writeText(text).then(function () {
    copyTextLang.value[name] = 'Copied to Clipboard';
    const to = setTimeout(() => {
      copyTextLang.value[name] = resetCopyTextLang.value[name];
      clearTimeout(to);
    }, 3000);
  }, function (err) {
    console.error('Async: Could not copy text: ', err);
  });
};

watch(() => showContact.value,
  val => {
    if (val) {
      const to = setTimeout(() => {
        $anime({
          targets: '.contact-text',
          opacity: 1,
          translateY: [20, 0],
          delay: $anime.stagger(50),
          duration: 1000,
          easing: 'easeOutExpo',
        });
        clearTimeout(to);
      }, 600);
    }
  },
);

</script>

<style lang="scss" scoped>

</style>
